import { DatePipe } from '@angular/common';

export class JsonManager {

    public static getBreakLineSeparatedErrorMessages(data: any): string {
        var errMessage: string = "";

        for (var key in data) {
            var tmp = (data[key]) + "<br>";

            errMessage += tmp;
        }

        return errMessage;
    }

    public static getDateTime() {
        var date;
        var pipe;

        pipe = new DatePipe('en-US');
        date = new Date();
        
        pipe.transform(date, 'yyyy-MM-dd');

        return pipe.transform(date, 'yyyy-MM-dd HH:mm:ss');
    }

    public static getDateTimeFormat(date: Date) {
        var pipe;

        pipe = new DatePipe('en-US');
        
        pipe.transform(date, 'yyyy-MM-dd');

        return pipe.transform(date, 'medium');
    }

}